module.exports = __webpack_public_path__ + "img/PR17.aaacb06d.png";